import { z } from 'zod';

export const conversationFileAttachmentSchema = z.object({
  fileKey: z.string(),
  fileName: z.string(),
  fileType: z.string(),
  fileUrl: z.string().url(),
  documentId: z.string().optional(),
});

export const interactiveAnswerRowSchema = z.object({
  rowId: z.string().min(1),
  value: z.string().min(1),
  makeRule: z.boolean(),
});

export const interactiveAnswersSubmissionSchema = z.object({
  messageId: z.string().min(1),
  answers: z.array(interactiveAnswerRowSchema).min(1),
});

export const postMessageSchema = z
  .object({
    content: z.string(),
    attachments: z.array(conversationFileAttachmentSchema).optional(),
    triggerAI: z.boolean().optional().default(true),
    internalNote: z.boolean().optional().default(false),
    interactiveAnswers: interactiveAnswersSubmissionSchema.optional(),
  })
  .refine(
    (v) => (v.content && v.content.trim().length > 0) || v.interactiveAnswers !== undefined,
    { message: 'content or interactiveAnswers is required' },
  );

export const createConversationSchema = z.object({
  title: z.string().optional(),
  initialMessage: z.string().min(1),
  attachments: z.array(conversationFileAttachmentSchema).optional(),
  transactionId: z.string().optional(),
  monthlyCloseId: z.string().optional(),
  threadType: z.enum(['SME_INIT', 'REVIEWER_AI']).optional().default('SME_INIT'),
});

export const updateConversationSchema = z.object({
  status: z.enum(['OPEN', 'NEEDS_REPLY', 'RESOLVED', 'ARCHIVED']).optional(),
  title: z.string().optional(),
});

export const listConversationsQuerySchema = z.object({
  status: z.enum(['OPEN', 'NEEDS_REPLY', 'RESOLVED', 'ARCHIVED']).optional(),
  threadType: z.enum(['ERIKO_INIT', 'REVIEWER_INIT', 'SME_INIT', 'REVIEWER_AI']).optional(),
  limit: z.coerce.number().int().min(1).max(100).optional().default(50),
});

export type PostMessageInput = z.infer<typeof postMessageSchema>;
export type CreateConversationInput = z.infer<typeof createConversationSchema>;
export type UpdateConversationInput = z.infer<typeof updateConversationSchema>;
